export interface ChatPattern {
    keywords: string[];
    responses: string[];
    category: 'order' | 'product' | 'guide' | 'faq' | 'greeting' | 'thanks';
}

export const chatPatterns: ChatPattern[] = [
    // Selamlaşma
    {
        keywords: ['merhaba', 'selam', 'hey', 'hi', 'hello', 'günaydın', 'iyi günler'],
        responses: [
            'Merhaba! 👋 Cheesecake İstanbul\'a hoş geldiniz. Size nasıl yardımcı olabilirim?',
            'Selam! 🍰 Bugün size nasıl yardımcı olabilirim?',
            'Merhaba! Size ürünlerimiz, siparişleriniz veya başka konularda yardımcı olabilirim.'
        ],
        category: 'greeting'
    },
    
    // Teşekkür
    {
        keywords: ['teşekkür', 'sağol', 'eyvallah', 'thanks', 'thank you'],
        responses: [
            'Rica ederim! 😊 Başka bir konuda yardımcı olabilir miyim?',
            'Ne demek! Size yardımcı olabildiysem ne mutlu bana. 🍰',
            'Her zaman! Başka sorunuz varsa çekinmeden sorun.'
        ],
        category: 'thanks'
    },

    // Sipariş Durumu
    {
        keywords: ['sipariş', 'sipariş durumu', 'siparişim', 'kargo', 'teslimat', 'nerede', 'geldi mi'],
        responses: [
            'Siparişlerinizi "Siparişlerim" sayfasından takip edebilirsiniz. 📦\n\nSol menüden "Siparişlerim" seçeneğine tıklayarak tüm siparişlerinizin detaylarını görebilirsiniz.',
            'Sipariş durumunuzu kontrol etmek için:\n\n1️⃣ Sol menüden "Siparişlerim"e gidin\n\n2️⃣ İlgili siparişe tıklayın\n\n3️⃣ Detaylı kargo takibi yapabilirsiniz 🚚'
        ],
        category: 'order'
    },

    // Sipariş Verme
    {
        keywords: ['nasıl sipariş', 'sipariş ver', 'nasıl alırım', 'satın al'],
        responses: [
            'Sipariş vermek çok kolay! 🛒\n\n1️⃣ "Ürünler" sayfasından istediğiniz ürünleri seçin\n\n2️⃣ Miktarı belirleyip sepete ekleyin\n\n3️⃣ Sepetinizi kontrol edin\n\n4️⃣ "Siparişi Tamamla" butonuna tıklayın\n\n5️⃣ Adres ve ödeme bilgilerinizi girin\n\nMinimum sipariş tutarı 3000 TL\'dir.',
            'Sipariş süreci:\n\n✅ Ürünler sayfasından ürün seçin\n\n✅ Sepete ekleyin (Min. 3000 TL)\n\n✅ Ödeme sayfasına geçin\n\n✅ Siparişinizi tamamlayın\n\nKolay ve hızlı! 🎉'
        ],
        category: 'guide'
    },

    // Ürün Önerileri
    {
        keywords: ['ürün öner', 'hangi ürün', 'ne almalı', 'tavsiye', 'öneri', 'popüler'],
        responses: [
            'En popüler ürünlerimiz:\n\n🍰 Klasik Cheesecake - Her zaman favoriler arasında\n🍓 Frambuazlı Cheesecake - Mevsimin yıldızı\n🍫 Çikolatalı Cheesecake - Çikolata severler için\n🥭 Mango Cheesecake - Tropikal lezzet\n\n"Ürünler" sayfasından tüm çeşitlerimizi görebilirsiniz!',
            'Size özel önerilerim:\n\n• Yeni başlıyorsanız: Klasik Cheesecake ile başlayın\n• Meyveli sevenler için: Frambuazlı veya Çilekli\n• Özel günler için: Premium Çikolatalı\n\nTüm ürünlerimiz katkısız ve 30 gün raf ömrüne sahip! 🌟'
        ],
        category: 'product'
    },

    // Ürün Bilgisi
    {
        keywords: ['ürün', 'cheesecake', 'fiyat', 'kaç tl', 'ne kadar', 'içerik', 'malzeme'],
        responses: [
            'Ürünlerimiz hakkında:\n\n✅ %100 doğal içerikler\n✅ Katkı ve koruyucu madde yok\n✅ 30 gün raf ömrü (dondurulmadan)\n✅ 200g porsiyon\n✅ El yapımı üretim\n\nFiyatlar üyelik seviyenize göre değişir:\n• Bronze: %0 indirim\n• Silver: %5 indirim\n• Gold: %10 indirim\n• Platinum: %15 indirim',
            'Cheesecake\'lerimizin özellikleri:\n\n🍰 Katkısız, doğal içerikler\n🍰 30 gün taze kalır\n🍰 200 gramlık zengin porsiyonlar\n🍰 Soğuk zincir ile teslimat\n\n"Ürünler" sayfasından detaylı bilgi alabilirsiniz!'
        ],
        category: 'product'
    },

    // Numune Talebi
    {
        keywords: ['numune', 'deneme', 'örnek', 'ücretsiz', 'bedava', 'test'],
        responses: [
            'Ücretsiz numune talebinde bulunabilirsiniz! 🎁\n\nNasıl?\n1. Ürünler sayfasından istediğiniz ürünü seçin\n2. "Numune" butonuna tıklayın\n3. Telefon numaranızı doğrulayın\n4. Adres bilgilerinizi girin\n\nÖnemli: Maksimum 3 farklı ürün için numune talep edebilirsiniz.',
            'Numune sistemi:\n\n✅ Tamamen ücretsiz\n✅ 3 farklı ürün hakkı\n✅ Telefon doğrulaması gerekli\n✅ 3-5 iş günü teslimat\n\nÜrün kartlarındaki "Numune" butonunu kullanın! 🎉'
        ],
        category: 'guide'
    },

    // Ödeme
    {
        keywords: ['ödeme', 'kredi kartı', 'havale', 'nasıl öde', 'eft'],
        responses: [
            'Ödeme seçeneklerimiz:\n\n💳 Kredi Kartı (Tek çekim veya taksit)\n💰 Havale/EFT\n\nGüvenli ödeme altyapımız ile tüm işlemleriniz korunur. Ödeme sayfasında detaylı bilgi bulabilirsiniz.',
            'Ödeme yapmak için:\n\n1. Sepetinizi tamamlayın\n2. "Siparişi Tamamla"ya tıklayın\n3. Ödeme yöntemini seçin\n4. Bilgilerinizi girin\n\nTüm ödemeler SSL ile güvence altında! 🔒'
        ],
        category: 'guide'
    },

    // Teslimat
    {
        keywords: ['teslimat', 'kargo', 'gönderim', 'ne zaman gelir', 'kaç gün'],
        responses: [
            'Teslimat bilgileri:\n\n📦 İstanbul içi: 1-2 iş günü\n📦 İstanbul dışı: 2-4 iş günü\n🚚 Soğuk zincir kargo ile gönderim\n❄️ Ürünler taptaze ulaşır\n\nStokta olmayan ürünler için özel üretim süresi eklenir.',
            'Kargo süreci:\n\n1. Siparişiniz hazırlanır\n2. Soğuk zincir ile paketlenir\n3. Kargo firmasına teslim edilir\n4. Takip numarası gönderilir\n\nTeslimat sırasında sorun olursa hemen bize ulaşın! 📞'
        ],
        category: 'faq'
    },

    // Üyelik
    {
        keywords: ['üyelik', 'seviye', 'bronze', 'silver', 'gold', 'platinum', 'indirim'],
        responses: [
            'Üyelik seviyeleri ve avantajları:\n\n🥉 Bronze: %0 indirim (Başlangıç)\n🥈 Silver: %5 indirim\n🥇 Gold: %10 indirim\n💎 Platinum: %15 indirim\n\nSipariş miktarınıza göre otomatik yükselirsiniz! Daha fazla bilgi için "Ayarlar" sayfasını ziyaret edin.',
            'Üyelik sistemi:\n\n• Alışverişleriniz birikir\n• Seviyeniz otomatik yükselir\n• Her seviyede daha fazla indirim\n• Özel kampanyalara erişim\n\nProfilinizden mevcut seviyenizi görebilirsiniz! 🌟'
        ],
        category: 'faq'
    },

    // İletişim
    {
        keywords: ['iletişim', 'iletisim', 'telefon', 'mail', 'email', 'whatsapp', 'ulaş', 'ulaşmak', 'ara', 'arama', 'kontak', 'contact', 'destek', 'yardım', 'müşteri hizmetleri'],
        responses: [
            'Bize ulaşmanın birçok yolu var! 📞\n\n🌐 İletişim Formu\nNavbar\'daki "İletişim" butonundan\n\n📧 E-posta\ninfo@cheesecakeistanbul.com\n\n📱 WhatsApp\nSağ alttaki yeşil WhatsApp butonundan\n\n📞 Telefon\n+90 (212) XXX XX XX\n\n7/24 size yardımcı olmaya hazırız!',
            'İletişim kanallarımız:\n\n✅ İletişim Formu\nEn üstteki menüden "İletişim"e tıklayın\n\n✅ E-posta\ninfo@cheesecakeistanbul.com\n\n✅ WhatsApp\nSağ alttaki yeşil buton\n\n✅ Telefon\nDirekt arama için\n\nEn hızlı yanıt için WhatsApp veya iletişim formunu kullanın! 💬'
        ],
        category: 'faq'
    },

    // SSS
    {
        keywords: ['sss', 'sık sorulan', 'faq', 'sorular'],
        responses: [
            'Sık Sorulan Sorular sayfamızı ziyaret edin! 📚\n\nNavbar\'daki "SSS" linkinden:\n• Ürün bilgileri\n• Sipariş süreci\n• Teslimat detayları\n• Ödeme seçenekleri\n\nve daha fazlası hakkında bilgi bulabilirsiniz.',
            'SSS sayfamızda şunları bulabilirsiniz:\n\n✅ Ürün özellikleri\n✅ Sipariş rehberi\n✅ Teslimat bilgileri\n✅ Ödeme seçenekleri\n✅ Üyelik sistemi\n\nNavbar\'dan "SSS"ye tıklayın!'
        ],
        category: 'faq'
    },

    // Minimum Sipariş
    {
        keywords: ['minimum', 'en az', 'kaç tl', 'alt limit', 'min sipariş', 'min tutar'],
        responses: [
            'Minimum sipariş tutarı: 3000 TL 💰\n\nBu tutar, toptan satış yapımız nedeniyle belirlenmiştir. Sepetinizde minimum tutarı görebilirsiniz.\n\nÜyelik seviyenize göre indirimler uygulanır!',
            'Minimum sipariş bilgisi:\n\n💰 3000 TL minimum tutar\n📦 Toptan satış için gerekli\n✅ Sepette otomatik kontrol edilir\n🎁 Üyelik indirimleri geçerli\n\nDaha fazla bilgi için "Hakkımızda" sayfasını ziyaret edin.'
        ],
        category: 'faq'
    },

    // Hakkımızda
    {
        keywords: ['hakkında', 'hakkınızda', 'kim', 'kimsiniz', 'firma', 'şirket', 'about'],
        responses: [
            'Cheesecake İstanbul olarak 30 yıldır kaliteli cheesecake üretimi yapıyoruz! 🍰\n\n✨ 30 yıllık tecrübe\n✨ %100 doğal içerikler\n✨ El yapımı üretim\n✨ Toptan satış\n\nDaha fazla bilgi için "Hakkımızda" sayfasını ziyaret edin!',
            'Biz kimiz?\n\n🏆 30 yıllık cheesecake üretim tecrübesi\n🍰 Katkısız, doğal ürünler\n📦 B2B toptan satış\n🌟 Binlerce mutlu müşteri\n\nNavbar\'dan "Hakkımızda"ya göz atın!'
        ],
        category: 'faq'
    },

    // Çalışma Saatleri
    {
        keywords: ['saat', 'açık', 'kapalı', 'çalışma saati', 'mesai', 'ne zaman açık'],
        responses: [
            'Çalışma saatlerimiz:\n\n🕐 Hafta içi: 09:00 - 18:00\n🕐 Cumartesi: 09:00 - 15:00\n🕐 Pazar: Kapalı\n\nOnline siparişlerinizi 7/24 verebilirsiniz! 🌐',
            'Mesai saatlerimiz:\n\n✅ Pazartesi-Cuma: 09:00-18:00\n✅ Cumartesi: 09:00-15:00\n❌ Pazar: Kapalı\n\nWeb sitemizden her zaman sipariş verebilirsiniz!'
        ],
        category: 'faq'
    },

    // Adres
    {
        keywords: ['adres', 'nerede', 'konum', 'lokasyon', 'address', 'neredesiniz'],
        responses: [
            'Adresimiz:\n\n📍 İstanbul, Türkiye\n\nDetaylı adres bilgisi için "İletişim" sayfasını ziyaret edin.\n\nTeslimat tüm Türkiye\'ye yapılmaktadır! 🚚',
            'Bizi bulun:\n\n📍 Merkez: İstanbul\n🚚 Teslimat: Tüm Türkiye\n\nİletişim sayfasından detaylı adres bilgisine ulaşabilirsiniz!'
        ],
        category: 'faq'
    },

    // Raf Ömrü
    {
        keywords: ['raf ömrü', 'dayanır', 'bozulur', 'sakla', 'saklama', 'muhafaza', 'kaç gün'],
        responses: [
            'Ürün saklama bilgileri:\n\n❄️ Buzdolabında: 30 gün\n🧊 Dondurucuda: 6 ay\n🌡️ +4°C\'de saklanmalı\n📦 Kapalı ambalajda\n\nÜrünlerimiz katkısız olduğu için soğuk zincir önemlidir!',
            'Raf ömrü:\n\n✅ 30 gün taze kalır (buzdolabı)\n✅ 6 ay dayanır (dondurucu)\n✅ +4°C\'de saklanmalı\n✅ Kapalı ambalajda\n\nDetaylı bilgi ürün etiketlerinde!'
        ],
        category: 'product'
    },

    // Alerjen
    {
        keywords: ['alerjen', 'alerjim', 'süt', 'yumurta', 'gluten', 'fındık', 'içerik'],
        responses: [
            'Alerjen bilgileri:\n\n⚠️ Süt ve süt ürünleri içerir\n⚠️ Yumurta içerir\n⚠️ Gluten içerebilir\n⚠️ Fındık içerebilir\n\nDetaylı içerik bilgisi için ürün sayfalarını inceleyin veya bize ulaşın!',
            'Ürünlerimizde:\n\n🥛 Süt ürünleri var\n🥚 Yumurta var\n🌾 Gluten olabilir\n🌰 Fındık olabilir\n\nAlerjiniz varsa lütfen ürün detaylarını kontrol edin!'
        ],
        category: 'product'
    },

    // Toptan Satış
    {
        keywords: ['toptan', 'wholesale', 'b2b', 'işletme', 'cafe', 'restoran', 'otel'],
        responses: [
            'Toptan satış yapıyoruz! 🏢\n\n✅ Cafe & Restoran\n✅ Otel & Pastane\n✅ Catering firmaları\n✅ Kurumsal müşteriler\n\nMinimum sipariş: 3000 TL\nÜyelik indirimleri mevcut!\n\nHemen üye olun ve avantajlardan yararlanın!',
            'B2B satış avantajları:\n\n💼 Toptan fiyatlar\n📦 Düzenli teslimat\n🎁 Üyelik indirimleri\n🌟 Özel kampanyalar\n\nİşletmeniz için ideal çözüm!'
        ],
        category: 'faq'
    },

    // İade
    {
        keywords: ['iade', 'geri gönder', 'iptal', 'cayma', 'return'],
        responses: [
            'İade politikamız:\n\n✅ Ürün hasarlı gelirse: Ücretsiz iade\n✅ Yanlış ürün gelirse: Değişim\n⏰ İade süresi: 14 gün\n📞 İletişim: Müşteri hizmetleri\n\nGıda ürünü olduğu için açılmış ürünlerde iade kabul edilmez.',
            'İade şartları:\n\n• Hasarlı/bozuk ürün: Tam iade\n• Yanlış ürün: Değişim\n• 14 gün içinde bildirim\n• Açılmamış ambalaj\n\nSorun yaşarsanız hemen bize ulaşın! 📞'
        ],
        category: 'faq'
    },

    // Kampanya
    {
        keywords: ['kampanya', 'indirim', 'promosyon', 'fırsat', 'discount', 'sale'],
        responses: [
            'Aktif kampanyalarımız:\n\n🎉 Üyelik indirimleri (Bronze-Platinum)\n🎁 İlk sipariş indirimi\n📦 Toplu alımlarda özel fiyat\n🌟 Sezonluk kampanyalar\n\n"Kampanyalar" sayfasından detayları görebilirsiniz!',
            'İndirim fırsatları:\n\n✨ Üyelik seviyesine göre %0-15 indirim\n✨ Özel günlerde ekstra kampanyalar\n✨ Toplu siparişte özel fiyat\n\nProfilinizden kampanyaları takip edin!'
        ],
        category: 'faq'
    }
];

// Türkçe karakterleri normalize et
const normalizeText = (text: string): string => {
    return text
        .toLowerCase()
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ı/g, 'i')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .trim();
};

// Mesajı analiz et ve en uygun yanıtı bul
export const findBestResponse = (userMessage: string): string => {
    const message = userMessage.toLowerCase().trim();
    const normalizedMessage = normalizeText(userMessage);
    
    // Boş mesaj kontrolü
    if (!message) {
        return 'Lütfen bir mesaj yazın. Size nasıl yardımcı olabilirim? 😊';
    }

    // En yüksek eşleşme skorunu bul
    let bestMatch: { pattern: ChatPattern; score: number } | null = null;

    for (const pattern of chatPatterns) {
        let score = 0;
        
        for (const keyword of pattern.keywords) {
            const normalizedKeyword = normalizeText(keyword);
            
            // Hem orijinal hem de normalize edilmiş metinde ara
            if (message.includes(keyword) || normalizedMessage.includes(normalizedKeyword)) {
                // Tam kelime eşleşmesi daha yüksek skor
                const regex = new RegExp(`\\b${keyword}\\b`, 'i');
                const normalizedRegex = new RegExp(`\\b${normalizedKeyword}\\b`, 'i');
                
                if (regex.test(message) || normalizedRegex.test(normalizedMessage)) {
                    score += 3; // Tam kelime eşleşmesi
                } else {
                    score += 1; // Kısmi eşleşme
                }
            }
        }

        if (score > 0 && (!bestMatch || score > bestMatch.score)) {
            bestMatch = { pattern, score };
        }
    }

    // Eşleşme bulunduysa rastgele bir yanıt döndür
    if (bestMatch) {
        const responses = bestMatch.pattern.responses;
        return responses[Math.floor(Math.random() * responses.length)];
    }

    // Eşleşme bulunamadıysa genel yanıt
    return `Üzgünüm, tam olarak anlayamadım. 🤔\n\nSize şu konularda yardımcı olabilirim:\n\n📦 Sipariş durumu ve takibi\n\n🍰 Ürün önerileri ve bilgileri\n\n🎁 Numune talebi\n\n💳 Ödeme ve teslimat\n\n👥 Üyelik sistemi\n\n📞 İletişim bilgileri\n\nYa da "SSS" sayfamızı ziyaret edebilirsiniz!`;
};

// Hızlı yanıt önerileri
export const quickReplies = [
    { text: 'Sipariş durumu', icon: '📦' },
    { text: 'Ürün öner', icon: '🍰' },
    { text: 'Nasıl sipariş veririm?', icon: '🛒' },
    { text: 'Numune talep et', icon: '🎁' },
    { text: 'İletişim bilgileri', icon: '📞' }
];
